import BaseComponent from '@/components/base';

export default class AccordionAdvanced extends BaseComponent {
  afterMount() {
    const slot = this.shadowRoot.querySelector('slot'); // Select the <slot> element
    if (slot) {
      const assignedElements = slot.assignedElements(); // Get elements assigned to the slot
      const accordionHeader = assignedElements.find(
        (el) => el.tagName === 'ACCORDION-HEADER'
      ); // Find the <accordion-header> element
      const accordionBody = assignedElements.find(
        (el) => el.tagName === 'ACCORDION-BODY'
      ); // Find the <accordion-body> element
      accordionHeader.addEventListener('click', () => {
        accordionHeader.shadowRoot
          .querySelector('.accordion-advanced-header')
          .classList.toggle('active');
        accordionBody.shadowRoot
          .querySelector('.accordion-advanced-body')
          .classList.toggle('active');
      });
    }
  }

  render() {
    return `
      <section class="accordion-advanced-wrapper">
        <slot></slot>
      </section>
    `;
  }
}
